module.exports = __webpack_public_path__ + "img/call-chart.47e7c61e.svg";